import wixLocation from 'wix-location';
import wixData from 'wix-data';
$w.onReady(function () {
    
    $w("#productPage1").getProduct().then(productFromPage => {
        $w("#image39").hide();
        wixData.query("Stores/Products")
            .eq("_id", productFromPage._id)
            .include("collections")
            .find()
            .then(products => {
                if (products.items.length === 1) {
                    $w("#image39").show();
                    let product = products.items[0]
                    if(product.collections.find(x => x._id === "3a3840a1-8153-01c6-f8fa-b66c3c49d60f")) {
                        let path = wixLocation.path;
                        wixLocation.to(`/product/${path[1]}`);
                    } else {
                        showProductPage()
                    }
                } else {
                    showProductPage()
                }
            }).catch(x => showProductPage())    
    }).catch(x => showProductPage()) 
} );

function showProductPage() {
    $w("#image39").hide();
    $w("#productPage1").show()
}

